import { render, staticRenderFns } from "./create.vue?vue&type=template&id=a02eff6c&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"
import style0 from "./create.vue?vue&type=style&index=0&id=a02eff6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02eff6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a02eff6c')) {
      api.createRecord('a02eff6c', component.options)
    } else {
      api.reload('a02eff6c', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=a02eff6c&scoped=true&", function () {
      api.rerender('a02eff6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl44/create.vue"
export default component.exports